import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpCenterDialogComponent } from './help-center-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { IconsModule } from 'src/app/icons/icons.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    HelpCenterDialogComponent
  ],
  imports: [
    CommonModule,
    IconsModule,
    MatDividerModule,
    SharedModule,
    MatDialogModule
  ],
  exports: [
    HelpCenterDialogComponent
  ]
})
export class HelpCenterDialogModule { }
